import moment from 'moment';
import * as XLSX from 'xlsx';

export type TChartType = 'line' | 'pie' | 'bar' | 'heatmap' | 'custom';

export const downloadXlsx = (
  chartType: TChartType,
  data: any[],
  fileName: string,
  sheetName: string
) => {
  let dataToExport = [];
  if (chartType === 'line') {
    const dateList = data[0].data.map((item) => item[0]);
    const convertedData = dateList.map((item, index) => {
      const row = { date: moment(item).format('DD-MM-YYYY') };

      data.forEach((seriesItem) => {
        row[seriesItem.name] = seriesItem.data[index]?.[1] ?? '';
      });

      return row;
    });

    dataToExport = convertedData;
  } else if (chartType === 'heatmap') {
    const time = [
      '00:00',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00'
    ];
    const convertedData = [];
    for (let i = 0; i < time.length; i++) {
      convertedData.push({
        time: time[i],
        monday: data.find((item) => item.name === 'monday')?.data?.[i],
        tuesday: data.find((item) => item.name === 'tuesday')?.data?.[i],
        wednesday: data.find((item) => item.name === 'wednesday')?.data?.[i],
        thursday: data.find((item) => item.name === 'thursday')?.data?.[i],
        friday: data.find((item) => item.name === 'friday')?.data?.[i],
        saturday: data.find((item) => item.name === 'saturday')?.data?.[i],
        sunday: data.find((item) => item.name === 'sunday')?.data?.[i]
      });
    }
    dataToExport = convertedData;
  } else if (chartType === 'bar') {
    const convertedData = data.map((item) => {
      const row = { category: item.name };
      item.data.forEach((element) => {
        row[element.x] = element.y;
      });
      return row;
    });
    dataToExport = convertedData;
  } else {
    dataToExport = data;
  }
  // Convert to worksheet
  const worksheet = XLSX.utils.json_to_sheet(dataToExport);
  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Download file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
